exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-6ca8cf74]{font-size:.24rem;color:#19191a;text-align:center}.button p span[data-v-6ca8cf74]{color:#2a2aff}.default-info[data-v-6ca8cf74]{bottom:.4rem;left:0;right:0;width:95%;margin:0 auto;text-align:center;color:#19191a;line-height:.34rem;font-size:.24rem}.default-info div span[data-v-6ca8cf74]{color:#2a2aff}.default-info .tips[data-v-6ca8cf74]{text-align:center;font-size:.24rem;font-weight:400;color:#19191a;line-height:.34rem}.default-info .tips span[data-v-6ca8cf74]{color:#2a2aff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ca8cf74","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/appointed-road-test/components/BottomLayout.vue
// module id = s+bv
// module chunks = 1